<template>
  <modal
    name="discussion-delete-modal"
    :classes="['discussion-delete-modal']"
    :height="'auto'"
    :width="'300px'"
    @before-open="beforeOpen"
  >
    <div class="title">
      Are you sure you want to delete this comment?
    </div>
    <div class="actions">
      <div
        class="ready"
        @click="yes"
      >
        Yes
      </div>
      <div
        class="back"
        @click="close"
      >
        No
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  emits: ['delete-discussion'],
  data() {
    return {
      discussion: undefined,
    };
  },
  methods: {
    close() {
      this.$modal.hide('discussion-delete-modal');
    },
    yes() {
      this.$store.dispatch('discussions/deleteDiscussion', { id: this.discussion.id }).then(() => {
        this.$emit('delete-discussion', this.discussion);
        this.close();
      });
    },
    beforeOpen(event) {
      if (event.params) {
        this.discussion = event.params.discussion;
      }
    },
  },
};
</script>

<style lang='scss'>
  .discussion-delete-modal {
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: rem-calc(32);
    text-align: center;

    .title {
      color: #12263b;
      font-size: rem-calc(20);
      font-weight: $bold;
      margin: rem-calc(20) 0;
      text-align: center;

      @include breakpoint(small) {
        font-size: rem-calc(24);
        margin-top: rem-calc(18);
      }
    }

    .text {
      color: #747E89;
      font-size: rem-calc(16);
      text-align: center;
    }

    .actions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: rem-calc(20);
      text-align: center;

      .back, .ready {
        border-radius: 4px;
        color: white;
        cursor: pointer;
        font-size: rem-calc(14);
        font-weight: $semi-bold;
        padding: rem-calc(8) rem-calc(20);
        width: rem-calc(72);


        @include breakpoint(large) {
          font-size: rem-calc(10);
        }

        @include breakpoint(small) {
          font-size: rem-calc(16);
          width: rem-calc(88);
        }
      }

      .back {
        background: red;
        margin-left: rem-calc(4);
      }

      .ready {
        background: #7bd56e;
        margin-right: rem-calc(4);
      }
    }
  }
</style>
